import React from 'react';
import PropTypes from 'prop-types';
import Chart from 'react-apexcharts';
import _ from 'lodash';

const BarChart = (props) => {
    const {
        chartOptions, chartSeries, height = '100%' 
    } = props;
    return (
        <Chart
            height={height}
            options={_.cloneDeep(chartOptions)}
            series={chartSeries.length ? _.cloneDeep(chartSeries) : [{ name: '', data: [] }]}
            type="bar"
            width="100%"
        />
    );
};

BarChart.propTypes = {
    chartOptions: PropTypes.object.isRequired,
    chartSeries: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            data: PropTypes.arrayOf(PropTypes.number).isRequired
        })
    ).isRequired,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default BarChart;
